import Joi from 'joi'

const DashboardBlockUpdatedEmailSignup = Joi.object()
    .keys({})
    .description('dashboard:block_updated:email_signup event attributes ')
    .meta({ name: 'DashboardBlockUpdatedEmailSignup', filename: 'dashboard:block_updated:email_signup.model' })

export default DashboardBlockUpdatedEmailSignup
